import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import Spinner from './components/Spinner';

type AuthContextType = {
  authChecked: boolean;
  isAuthenticated: boolean;
  userId?: string | null;
};

const AuthContext = createContext<AuthContextType>({ authChecked: false, isAuthenticated: false, userId: null });

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [authChecked, setAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userId, setUserId] = useState<string | null>(null);

  useEffect(() => {
    const baseEnv = process.env.REACT_APP_API_URL || '';
    const hostname = window.location.hostname;
    const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1';
    let baseNoSlash = '';
    try {
      if (isLocalHost) {
        baseNoSlash = '';
      } else if (baseEnv) {
        const envUrl = new URL(baseEnv);
        baseNoSlash = envUrl.origin === window.location.origin ? '' : baseEnv.replace(/\/$/, '');
      }
    } catch {
      baseNoSlash = baseEnv ? baseEnv.replace(/\/$/, '') : '';
    }
    const url = baseNoSlash ? `${baseNoSlash}/api/test-session` : '/api/test-session';

    axios.get(url, { withCredentials: true })
      .then((response: any) => {
        const sid = response.data?.session?.userId;
        if (sid) {
          setIsAuthenticated(true);
          setUserId(sid);
        } else {
          setIsAuthenticated(false);
          setUserId(null);
        }
      })
      .catch(() => {
        setIsAuthenticated(false);
        setUserId(null);
      })
      .finally(() => setAuthChecked(true));
  }, []);

  if (!authChecked) {
    // render global spinner until auth is known
    return <Spinner message="" />;
  }

  return (
    <AuthContext.Provider value={{ authChecked, isAuthenticated, userId }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
